import React from 'react';
import MainBanner from '../components/pageHeaderComponents/MainBanner';

const PageHeader = () => {
  return (
    <div id="page-header">
      <div id="main-banner-wrapper">
        <MainBanner />
      </div>
    </div>
  );
};

export default PageHeader;
